import { lazy } from 'react';
const LatexOrders = lazy(() => import('./LatexOrders'));

const LatexOrdersRoutes = [
  {
    path: '/latexorders',
    component: LatexOrders
  }
];

export default LatexOrdersRoutes;
